import { Thumbnails } from '@frameio/shared/components/Thumbnails';
import type { NotificationGroupInfo } from '../types';
import { useThumbsFragment } from './gql/generated/Thumbs';

/**
 * renders mosaic of thumbs according to length and size of thumbs array
 * note MediaThumbnailGroup did not fit our design specs and we created
 * our own wrapper
 */
export function Thumbs({ id, notificationType }: NotificationGroupInfo) {
  const { complete, data } = useThumbsFragment({
    from: { id, __typename: notificationType },
  });

  const thumbs = 'content' in data ? data?.content?.thumbs : null;

  if (!complete || !thumbs) return null;

  return (
    <Thumbnails
      thumbs={thumbs
        .filter((thumb) => !!thumb && !!thumb.asset)
        .map((thumb) => {
          const asset = thumb!.asset!;
          const mediaType =
            'media' in asset ? asset.media?.__typename : undefined;

          return {
            id: asset.id!,
            type: asset.__typename!,
            mediaType,
            media: asset,
          };
        })}
    />
  );
}
